










import { Vue, Component } from 'vue-property-decorator';
import ConfigurarAlertas from '@/pantallas/Camaras/ConfigurarAlertas/ConfigurarAlertas.vue';

@Component({
  components: { ConfigurarAlertas },
})
export default class ConfigurarAlertasPantalla extends Vue {}
